/* custom.js — Vanilla JS only, no jQuery, no slick */

document.addEventListener('DOMContentLoaded', function () {

  /* ═══════════════════════════════════════════════════════
     1. TAB NAV  (.tab_nav li / .tabcontent)
  ═══════════════════════════════════════════════════════ */
  (function () {
    var navItems   = document.querySelectorAll('.tab_nav li');
    var tabPanels  = document.querySelectorAll('.tabcontent');
    if (!navItems.length) return;

    // Init: activate first
    navItems[0].classList.add('active');
    tabPanels.forEach(function (p) { p.style.display = 'none'; });
    if (tabPanels[0]) tabPanels[0].style.display = '';

    navItems.forEach(function (li) {
      li.addEventListener('click', function (e) {
        e.preventDefault();
        navItems.forEach(function (n) { n.classList.remove('active'); });
        li.classList.add('active');

        var href = li.querySelector('a') ? li.querySelector('a').getAttribute('href') : null;
        tabPanels.forEach(function (p) { p.style.display = 'none'; });
        if (href) {
          var target = document.querySelector(href);
          if (target) {
            target.style.display = '';
            target.style.animation = 'fadeIn 0.25s ease';
          }
        }
      });
    });
  })();

  /* ═══════════════════════════════════════════════════════
     2. FAQ ACCORDION  (.ques-heading / .ques-desc)
  ═══════════════════════════════════════════════════════ */
  (function () {
    var headings = document.querySelectorAll('.ques-heading');
    if (!headings.length) return;

    function slideUp(el) {
      el.style.maxHeight = el.scrollHeight + 'px';
      el.offsetHeight; // force reflow
      el.style.transition = 'max-height 0.28s ease, opacity 0.22s ease';
      el.style.overflow = 'hidden';
      el.style.maxHeight = '0';
      el.style.opacity = '0';
    }

    function slideDown(el) {
      el.style.maxHeight = '0';
      el.style.overflow = 'hidden';
      el.style.opacity = '0';
      el.style.transition = 'max-height 0.28s ease, opacity 0.22s ease';
      el.offsetHeight;
      el.style.maxHeight = el.scrollHeight + 'px';
      el.style.opacity = '1';
    }

    headings.forEach(function (heading) {
      heading.addEventListener('click', function (e) {
        e.preventDefault();
        var row  = heading.closest('.questions__item_row');
        var body = heading.closest('.question-body');
        var desc = row ? row.querySelector('.ques-desc') : null;
        if (!desc) return;

        // Close all others in the same body
        if (body) {
          body.querySelectorAll('.ques-desc').forEach(function (d) {
            if (d !== desc) slideUp(d);
          });
          body.querySelectorAll('.ques-heading.active').forEach(function (h) {
            if (h !== heading) h.classList.remove('active');
          });
        }

        if (heading.classList.contains('active')) {
          heading.classList.remove('active');
          slideUp(desc);
        } else {
          heading.classList.add('active');
          slideDown(desc);
        }
      });
    });
  })();

  /* ═══════════════════════════════════════════════════════
     3. TAB HEADER  (.tab-header-item / .tab-content-item)
  ═══════════════════════════════════════════════════════ */
  (function () {
    var tabHeaders = document.querySelectorAll('.tab-header-item');
    if (!tabHeaders.length) return;

    tabHeaders.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabHeaders.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        var toOpen = btn.getAttribute('tab_content');
        document.querySelectorAll('.tab-content-item').forEach(function (c) {
          c.style.display = 'none';
        });
        var target = document.querySelector('[content="' + toOpen + '"]');
        if (target) target.style.display = '';
      });
    });
  })();

  /* ═══════════════════════════════════════════════════════
     4. MOBILE TAB HEADER  (.tab-header-item-mob)
  ═══════════════════════════════════════════════════════ */
  (function () {
    var mobHeaders = document.querySelectorAll('.tab-header-item-mob');
    if (!mobHeaders.length) return;

    mobHeaders.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('active');
        var toOpen = btn.getAttribute('tab_content');
        var target = document.querySelector('[content="' + toOpen + '"]');
        if (!target) return;

        if (btn.classList.contains('active')) {
          target.style.maxHeight = target.scrollHeight + 'px';
          target.style.overflow = 'hidden';
          target.style.transition = 'max-height 0.3s ease';
        } else {
          target.style.maxHeight = '0';
        }
      });
    });
  })();

  /* ═══════════════════════════════════════════════════════
     5. REVIEWS CAROUSEL  (.reviews-carucel)
        Reemplaza slick: dot nav + autoplay + swipe/drag
  ═══════════════════════════════════════════════════════ */
  (function () {
    var tracks = document.querySelectorAll('.reviews-carucel');
    if (!tracks.length) return;

    tracks.forEach(function (track) {
      var slides = Array.from(track.children);
      if (slides.length < 2) return;

      var current    = 0;
      var autoTimer  = null;
      var startX     = 0;
      var isDragging = false;

      // Wrap in container
      var wrapper = document.createElement('div');
      wrapper.className = 'rev-carousel-wrap';
      wrapper.style.cssText = 'position:relative;overflow:hidden;width:100%';
      track.parentNode.insertBefore(wrapper, track);
      wrapper.appendChild(track);

      track.style.cssText = 'display:flex;transition:transform 0.4s ease;will-change:transform;';
      slides.forEach(function (s) {
        s.style.cssText = 'flex:0 0 100%;width:100%;min-width:100%;box-sizing:border-box;';
      });

      // Dots
      var dotsWrap = document.createElement('div');
      dotsWrap.style.cssText = 'display:flex;justify-content:center;gap:8px;margin-top:12px;';
      var dots = slides.map(function (_, i) {
        var d = document.createElement('button');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.style.cssText = 'width:8px;height:8px;border-radius:50%;border:0;padding:0;cursor:pointer;background:rgba(0,0,0,0.2);transition:background 0.2s;';
        d.addEventListener('click', function () { goTo(i); resetTimer(); });
        dotsWrap.appendChild(d);
        return d;
      });
      wrapper.appendChild(dotsWrap);

      function goTo(idx) {
        current = (idx + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        dots.forEach(function (d, i) {
          d.style.background = i === current ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0.2)';
        });
      }

      function next() { goTo(current + 1); }

      function resetTimer() {
        clearInterval(autoTimer);
        autoTimer = setInterval(next, 10000);
      }

      // Touch / mouse drag
      track.addEventListener('pointerdown', function (e) {
        startX = e.clientX; isDragging = true;
        track.style.transition = 'none';
      });
      track.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        var diff = e.clientX - startX;
        track.style.transform = 'translateX(calc(-' + current * 100 + '% + ' + diff + 'px))';
      });
      track.addEventListener('pointerup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = 'transform 0.4s ease';
        var diff = e.clientX - startX;
        if (diff < -50) next();
        else if (diff > 50) goTo(current - 1);
        else goTo(current);
        resetTimer();
      });
      track.addEventListener('pointercancel', function () {
        if (isDragging) { isDragging = false; goTo(current); }
      });

      goTo(0);
      resetTimer();
    });
  })();

  /* ═══════════════════════════════════════════════════════
     6. LOGO CAROUSEL  (.logo-list-carucell)
        Reemplaza slick: CSS infinite marquee + pause on hover
  ═══════════════════════════════════════════════════════ */
  (function () {
    var carousels = document.querySelectorAll('.logo-list-carucell');
    if (!carousels.length) return;

    carousels.forEach(function (carousel) {
      var items = Array.from(carousel.children);
      if (!items.length) return;

      // Duplicate items for seamless loop
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        carousel.appendChild(clone);
      });

      carousel.style.cssText = [
        'display:flex',
        'width:max-content',
        'animation:logoMarquee 22s linear infinite',
        'will-change:transform',
      ].join(';');

      var parent = carousel.parentElement;
      parent.style.cssText = 'overflow:hidden;width:100%;';

      parent.addEventListener('mouseenter', function () {
        carousel.style.animationPlayState = 'paused';
      });
      parent.addEventListener('mouseleave', function () {
        carousel.style.animationPlayState = 'running';
      });
    });

    // Inject keyframes once
    if (!document.getElementById('logo-marquee-style')) {
      var style = document.createElement('style');
      style.id = 'logo-marquee-style';
      style.textContent = [
        '@keyframes logoMarquee {',
        '  0%   { transform: translateX(0); }',
        '  100% { transform: translateX(-50%); }',
        '}',
        '@media (max-width: 768px) {',
        '  .logo-list-carucell { animation-duration: 18s !important; }',
        '}',
      ].join('\n');
      document.head.appendChild(style);
    }
  })();

  /* ═══════════════════════════════════════════════════════
     7. fadeIn keyframe (usado por tab_nav)
  ═══════════════════════════════════════════════════════ */
  if (!document.getElementById('vanillajs-fadein')) {
    var s = document.createElement('style');
    s.id = 'vanillajs-fadein';
    s.textContent = '@keyframes fadeIn { from { opacity:0 } to { opacity:1 } }';
    document.head.appendChild(s);
  }

});
